import { useEffect, useState } from "react";

export default function useGet(fatchData){
    const [data,setData] = useState({});

    let apiCheck = false;

    const headersData = fatchData.loginType == "login" ? {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + localStorage.getItem("token"),
            'Accept' : 'application/json'
        },
    } : fatchData.loginType == "sessionLogin" ? {
        method: "GET",
        headers: {
            'Authorization': 'Bearer ' + sessionStorage.getItem("token"),
            'Accept' : 'application/json'
        },
    } : {
        method: "GET",
        headers: {
            'Accept' : 'application/json'
        },
    }

    useEffect(() => {
        if (!apiCheck) {
            apiCheck = true
            if((fatchData.chk || fatchData.chk == undefined || fatchData.chk == null) && fatchData.url){
                fetch(`${process.env.REACT_APP_API_URL}${fatchData.url}`, headersData)
                .then(function(response) {
                    if (response?.status === 401) {
                        localStorage.removeItem("token");
                        localStorage.removeItem("refresh_token");
                        window.alert("잘못된 접근입니다")
                        window.location.href = `/login`;
                    } else if(response?.status !== 200){
                        window.alert("잘못된 접근입니다")
                        window.location.href = `/dashboard`;
                    }
                    return response.json();
                }).then(function(fetchRd) {
                    apiCheck = false
                    if (fetchRd.success == true) {
                        setData(fetchRd);
                    }else{
                        setData(fetchRd);
                    }
                });
            }
        }
    },[fatchData.url, fatchData.mutate]);

    return data;
}